import React from 'react';
import PropTypes from 'prop-types';
import { generateMetricsAttribute } from '@sm/metrics';
import { Container, Typography } from '@sm/wds-react';
import { Button } from '@wds/button';
import { createURL } from '@sm/utils';

import './fortune-callout.scss';

const FortuneCallout = ({ color, copy, ctaText, utSource, utSource2, hideCTAs }) => (
  <Container
    data-testid="FortuneCallout"
    flex
    flexJustify="center"
    flexDirection="column"
    className={`sm-fortune-callout sm-fortune-callout--${color} wds-p-7`}
  >
    <Typography
      component="h3"
      align="center"
      variant="sectionTitle"
      color="primary"
      className="sm-fortune-callout__copy"
    >
      <strong>{copy}</strong>
    </Typography>
    <Choose>
      <When condition={hideCTAs} />
      <Otherwise>
        <Button
          size="lg"
          color="primary"
          pl={5}
          pr={5}
          mt={6}
          href={createURL('/user/sign-up/', {
            ut_source: utSource,
            ut_source2: utSource2,
          })}
          data-sm-metric={generateMetricsAttribute({
            data: {
              actionType: `${utSource}_click_fortune_cta_to_sign_up`,
              actionFlow: { utSource },
            },
          })}
        >
          {ctaText}
        </Button>
      </Otherwise>
    </Choose>
  </Container>
);

FortuneCallout.propTypes = {
  color: PropTypes.string,
  copy: PropTypes.string.isRequired,
  ctaText: PropTypes.string.isRequired,
  utSource: PropTypes.string,
  utSource2: PropTypes.string,
  hideCTAs: PropTypes.bool,
};

FortuneCallout.defaultProps = {
  color: 'canvas',
  utSource: '',
  utSource2: '',
  hideCTAs: false,
};

export default FortuneCallout;
